export default {
  SELECT_LOCATION: 'segmentCreation/SELECT_LOCATION',
  DESELECT_LOCATION: 'segmentCreation/DESELECT_LOCATION',
  FLIP_SELECTED_LOCATIONS: 'segmentCreation/FLIP_SELECTED_LOCATIONS',
  SELECT_PATH_SUGGESTION: 'segmentCreation/SELECT_PATH_SUGGESTION',
  SET_PATH_SUGGESTIONS: 'segmentCreation/SET_PATH_SUGGESTIONS',
  SET_CREATED_SEGMENT_ID: 'segmentCreation/SET_CREATED_SEGMENT_ID',
  CLEAR_CREATE_SEGMENT: 'segmentCreation/CLEAR_CREATE_SEGMENT',
  START_CREATE_OPPOSITE_SEGMENT: 'segmentCreation/START_CREATE_OPPOSITE_SEGMENT',
};



// WEBPACK FOOTER //
// ./src/state/ducks/segmentCreation/types.js